import { ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';
import { FormComponent } from '@tdwb/core';
import { AgreementsDateBaseDirective } from '../agreements.base';
export interface NyseAgreementFormModel {
  clientName: string,
  clientAddress: string,
  clientOccupation: string,
  clientEmployerNameAddress: string,
  clientTitlePosition: string,
  clientEmployerFunction: string
}
@Component({
  selector: 'td-wb-nyse-agreement',
  templateUrl: './nyse-agreement.component.html',
  styleUrls: ['../agreements.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class NyseAgreementComponent extends AgreementsDateBaseDirective {

  @ViewChild(FormComponent) form: FormComponent;
  @ViewChild('btn') btn: ElementRef;

  formModel: NyseAgreementFormModel = {
    clientName: '',
    clientAddress: '',
    clientOccupation: '',
    clientEmployerNameAddress: '',
    clientTitlePosition: '',
    clientEmployerFunction: ''
  };

  trySubmitAndReturnModel(): NyseAgreementFormModel {
    return super.trySubmit(this.form) ? this.formModel : undefined;
  }

}
